import axios from "axios";
import { useState } from "react";
import { ArtSkillDataType, ExtensionDataType, FilterRarityType, HeroDataType } from "../../components/assetSettingModal/hooks/AssetSettingModalType";

export type AssetType = {
    heros: HeroDataType[]
    extensions: ExtensionDataType[],
    isAssetLoading: boolean,
    artSkilles: ArtSkillDataType[],
    feacthAssetData: () => void,
    filterHeroData: (heros: HeroDataType[], rarity: FilterRarityType) => HeroDataType[]
    filterExtensionData: (extensions: ExtensionDataType[], rarity: FilterRarityType) => ExtensionDataType[]
};

export const useAssetProvide = (): AssetType => {
    const [heros, setHeros] = useState<HeroDataType[]>([]);
    const [extensions, setExtensions] = useState<ExtensionDataType[]>([]);
    const [artSkilles, setArtSkilles] = useState<ArtSkillDataType[]>([]);
    const [isAssetLoading, setIsAssetLoading] = useState(true);


    const feacthAssetData = async () => {
        await feacthHeroData();
        await feacthExtensionData();
        await feacthArtSkillData();
        setIsAssetLoading(false);
    }
    const feacthHeroData = async () => {
        axios.get(`https://mch-dragon-simulator.herokuapp.com/api/hero/all`)
            .then(res => {
                setHeros(res.data)
            })
    }
    const feacthExtensionData = async () => {
        axios.get(`https://mch-dragon-simulator.herokuapp.com/api/extension/all`)
            .then(res => {
                setExtensions(res.data)
            })
    }

    const feacthArtSkillData = async () => {
        axios.get(`https://mch-dragon-simulator.herokuapp.com/api/art/all`)
            .then(res => {
                setArtSkilles(res.data)
            })
    }

    const filterHeroData = (heros: HeroDataType[], rarity: FilterRarityType): HeroDataType[] => {
        switch (rarity) {
            case "Legendary":
                return heros.filter(hero => hero.rarity === 5);
            case "Epic":
                return heros.filter(hero => hero.rarity === 4);
            case "Rare":
                return heros.filter(hero => hero.rarity === 3);
            case "Uncommon":
                return heros.filter(hero => hero.rarity === 2);
            case "Common":
                return heros.filter(hero => hero.rarity === 1);
            default:
                return heros
        }
    }

    const filterExtensionData = (extensions: ExtensionDataType[], rarity: FilterRarityType): ExtensionDataType[] => {
        switch (rarity) {
            case "Legendary":
                return extensions.filter(extension => extension.rarity === 5);
            case "Epic":
                return extensions.filter(extension => extension.rarity === 4);
            case "Rare":
                return extensions.filter(extension => extension.rarity === 3);
            case "Uncommon":
                return extensions.filter(extension => extension.rarity === 2);
            case "Common":
                return extensions.filter(extension => extension.rarity === 1);
            default:
                return extensions
        }
    }
    return { heros, extensions, artSkilles, isAssetLoading, feacthAssetData, filterHeroData, filterExtensionData };
};
